import React from "react";
import { Line } from "react-chartjs-2";
import { RotatingLines } from "react-loader-spinner";
import { useChartData } from "../../../hooks/useChartData";

const SalesChart = ({ initialData }) => {
  const { chartData, gettingData, getYearData, getMonthData, getWeekData } = useChartData(initialData);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 h-full">
      <div className="p-3 pb-0">
        <div className="flex justify-between items-center mb-6">
          <h5 className="flex items-center text-lg font-semibold text-gray-800 mb-0">
            <svg 
              className="w-6 h-6 mr-3 text-blue-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" 
              />
            </svg>
            <span>Sales statistics</span>
          </h5>
          
          <div className="flex flex-wrap gap-1 border border-gray-200 items-center justify-center">
            <label className="cursor-pointer mt-1">
              <input
                type="radio"
                name="order__statistics"
                className="sr-only peer"
                defaultChecked={true}
              />
              <span 
                className="px-2 py-1 text-sm font-sm text-gray-600 transition-all duration-200 peer-checked:bg-blue-600 peer-checked:text-white hover:bg-blue-50 hover:text-blue-700"
                data-order-type="yearOrder" 
                onClick={getYearData}
              >
                This Year
              </span>
            </label>
            
            <label className="cursor-pointer mt-1">
              <input
                type="radio"
                name="order__statistics"
                className="sr-only peer"
              />
              <span 
                className="px-2 py-1 text-sm font-sm text-gray-600 transition-all duration-200 peer-checked:bg-blue-600 peer-checked:text-white hover:bg-blue-50 hover:text-blue-700"
                data-order-type="MonthOrder" 
                onClick={getMonthData}
              >
                This Month
              </span>
            </label>
            
            <label className="cursor-pointer mt-1">
              <input
                type="radio"
                name="order__statistics"
                className="sr-only peer"
              />
              <span 
                className="px-2 py-1 text-sm font-sm text-gray-600 transition-all duration-200 peer-checked:bg-blue-600 peer-checked:text-white hover:bg-blue-50 hover:text-blue-700"
                data-order-type="WeekOrder" 
                onClick={getWeekData}
              >
                This Week
              </span>
            </label>
          </div>
        </div>
        
        <div id="updatingOrderData">
          {!gettingData && chartData ? (
            <div className="mb-4">
              <Line options={options} data={chartData} />
            </div>
          ) : (
            <div className="h-96 flex items-center justify-center">
              <RotatingLines
                visible={true}
                height="96"
                width="96"
                strokeColor="#3b82f6"
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesChart;